import { LOAD_ADMIN_USERS } from "./users";

const initialState = { start: 1, end: 2, selected: 1 };

const SET_PAGINATION = "SET_PAGINATION";

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOAD_ADMIN_USERS.SUCCESS: {
      const { total } = action.payload;
      return { ...state, end: total };
    }
    case SET_PAGINATION: {
      return { ...state, selected: action.payload };
    }
    default:
      return state;
  }
}

export const setPagination = start => {
  return {
    type: SET_PAGINATION,
    payload: start
  };
};
